<template>
  <div>
    <!-- <b-row>
      <b-col
        :cols="gridColsDetail"
        :lg="gridColsDetailLg"
        class="d-flex justify-content-between mb-3"
      >
        <div class="h5 font-weight-bold font-size-lg d-flex align-items-center">
          Micro-credential basic info
        </div>
        <b-button
          v-if="
            editable &&
              !(learningUnit.is_published || learningUnit.required_review)
          "
          ref="button__edit"
          :disabled="disabled"
          variant="outline-primary"
          @click="goToEditPage()"
        >
          <span>Edit basic info</span>
        </b-button>
      </b-col>
    </b-row> -->

    <b-row class="justify-content-center info">
      <b-col v-if="showGeneralAndLearningAccordions" cols="12">
        <base-accordions :accordion-id="'general-info'" :title="'General info'">
          <b-col class="d-flex justify-content-between mb-4 px-0">
            <div class="text-black-50 d-flex align-items-center">
              Edit to view and manage the list of information for this MC.
            </div>
            <b-button
              :ref="editable.learning ? 'button__edit' : 'button__view'"
              :class="`button__${editable.learning ? 'edit' : 'view'}`"
              class="text-capitalize"
              variant="outline-primary"
              @click="goToEditGeneralInfoPage(editable.learning ? 'edit' : 'view')"
            >
              <span>{{ editable.learning ? 'edit' : 'view' }}</span>
            </b-button>
          </b-col>
        </base-accordions>
      </b-col>

      <b-col cols="12">
        <base-accordions :accordion-id="'method'" :title="'Method'">
          <b-col
            :cols="gridColsDetail"
            :lg="gridColsDetailLg"
            class="d-flex justify-content-between mb-4 px-0"
          >
            <div class="text-black-50 d-flex align-items-center">
              Edit to view and manage all the method topics.
            </div>
            <b-button
              v-if="editable.method"
              :ref="`button__${textButton}`"
              :class="`button__${textButton}`"
              class="text-capitalize"
              :disabled="disabled"
              variant="outline-primary"
              @click="goToEditMethodPage(textButton)"
            >
              <span>{{ textButton }}</span>
            </b-button>
            <b-button
              v-else
              ref="button__view"
              class="button__view"
              variant="outline-primary"
              @click="goToEditMethodPage('view')"
            >
              View
            </b-button>
          </b-col>
        </base-accordions>
      </b-col>

      <b-col v-if="showGeneralAndLearningAccordions" cols="12">
        <base-accordions :accordion-id="'learning'" :title="'Learning'">
          <b-col
            :cols="gridColsDetail"
            :lg="gridColsDetailLg"
            class="d-flex justify-content-between mb-4 px-0"
          >
            <div class="text-black-50 d-flex align-items-center">
              Edit to view and manage an learning unit overview, outcomes and content example.
            </div>
            <b-button
              :ref="editable.learning ? 'button__edit' : 'button__view'"
              variant="outline-primary"
              @click="goToEditLearningPage(editable.learning ? 'edit' : '')"
            >
              <span>{{ editable.learning ? 'Edit' : 'View' }}</span>
            </b-button>
          </b-col>

          <!-- summary overview -->
          <!-- <b-col
            ref="text__lu-summary-overview"
            :cols="gridColsDetail"
            :lg="gridColsDetailLg"
            class="mb-4 px-0"
          >
            <div class="mb-3 text__lu-summary-overview">
              <b>Learning unit overview</b>
            </div>

            <base-text-editor-display v-if="learningUnit.summary_overview">
              <div
                id="summary-overview"
                v-safe-html="learningUnit.summary_overview"
                class="text__lu-summary-overview mb-3"
              />
            </base-text-editor-display>

            <div v-else>No information to display.</div>

            <b-col class="px-0" :cols="gridColsHorizontalRule">
              <hr />
            </b-col> -->

          <!-- summary outcome -->
          <!-- <div class="mb-3 text__lu-summary-outcome">
              <b>Outcomes</b>
            </div>

            <base-text-editor-display v-if="learningUnit.summary_outcome">
              <div
                id="summary-outcome"
                v-safe-html="learningUnit.summary_outcome"
                class="text__lu-summary-outcome mb-3"
              />
            </base-text-editor-display>

            <div v-else>No information to display.</div>
          </b-col>

          <b-col class="px-0" :cols="gridColsHorizontalRule">
            <hr />
          </b-col> -->

          <!-- content example -->
          <!-- <b-col
            ref="text__lu-content-example"
            :cols="gridColsDetail"
            :lg="gridColsDetailLg"
            class="mt-3 mb-4 px-0"
          >
            <div class="mb-3 text__title-content-example">
              <b>Content Example</b>
            </div>

            <base-text-editor-display v-if="learningUnit.content">
              <div
                id="content-example"
                v-safe-html="learningUnit.content"
                class="text__lu-content-example mb-3"
              />
            </base-text-editor-display>

            <div v-else>No information to display.</div>

            <base-presigned-image
              v-if="learningUnit.content_media[0]"
              class="img__media-detail"
              style="max-width: 200px"
              fluid-grow
              :file-id="learningUnit.content_media[0].id"
            ></base-presigned-image>

            <base-video-bunny-player
              v-if="learningUnit.bunny_video"
              :width="500"
              :height="300"
              :bunny-video="learningUnit.bunny_video"
              class="mt-3 container__preview-video-content"
            />
          </b-col> -->
        </base-accordions>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LearningUnitType from '@/models/LearningUnitType';
import { learningUnitInfoMixin } from '@/mixins/learningUnitInfoMixin';
import { commonStyleDescriptionMixin } from '@/mixins/commonStyleDescriptionMixin';
import BaseAccordions from '@/components/base-components/BaseAccordions.vue';

export default {
  components: {
    BaseAccordions
  },
  mixins: [learningUnitInfoMixin, commonStyleDescriptionMixin],

  props: {
    disabled: {
      type: [Number, Boolean],
      default: false
    },
    hideTitle: {
      type: [Number, Boolean],
      default: false
    },
    hideDescription: {
      type: [Number, Boolean],
      default: false
    },
    hideType: {
      type: [Number, Boolean],
      default: false
    },
    hideWhatToDo: {
      type: [Number, Boolean],
      default: false
    },
    hideHowToPrepare: {
      type: [Number, Boolean],
      default: false
    },
    hideWhatThisFor: {
      type: [Number, Boolean],
      default: false
    },
    hideCoverIdea: {
      type: [Number, Boolean],
      default: false
    },
    hideCoverImage: {
      type: [Number, Boolean],
      default: false
    },
    hideLearningUnitLink: {
      type: [Number, Boolean],
      default: false
    },
    hideVisibility: {
      type: [Number, Boolean],
      default: false
    },
    titleWhatToDo: {
      type: String,
      default: 'What are learners going to do'
    },
    gridColsDetail: {
      type: String,
      default: '12'
    },
    gridColsDetailLg: {
      type: String,
      default: '12'
    },
    gridColsHorizontalRule: {
      type: String,
      default: '12'
    },
    editable: {
      type: Object,
      default: () => {
        return {
          generalInfo: false,
          method: false,
          learning: false
        };
      }
    },
    mode: {
      type: String,
      default: 'instructor'
    },
    hasMethodComponent: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      height: 50
    };
  },

  computed: {
    test() {
      return (
        this.learningUnit.media_detail_vimeo &&
        this.learningUnit.media_detail_vimeo.video_link &&
        !this.learningUnit.media_detail_vimeo.isVideoAvailable
      );
    },
    typeCheckLists() {
      return LearningUnitType.getDetailType(this.type);
    },

    typeLink() {
      return this.type == 'General'
        ? 'https://www.canva.com/design/DAEjlSlodXQ/JFnCQLd5auDNKSJ7wImSrw/view?utm_content=DAEjlSlodXQ&utm_campaign=designshare&utm_medium=link&utm_source=homepage_design_menu#4'
        : 'https://www.canva.com/design/DAEjlSlodXQ/JFnCQLd5auDNKSJ7wImSrw/view?utm_content=DAEjlSlodXQ&utm_campaign=designshare&utm_medium=link&utm_source=homepage_design_menu#5';
    },

    textButton() {
      return this.hasMethodComponent ? 'edit' : 'create';
    },
    isOwner() {
      return this.$currentUser?.isOwnerOf(this.learningUnit?.id);
    },
    showGeneralAndLearningAccordions() {
      return this.mode !== 'assessor' || this.isOwner;
    }
  },

  mounted() {
    this.commonIdAttributes('description');
  },

  methods: {
    copyLink() {
      const copy = this.$refs.link.value;
      navigator.clipboard.writeText(copy);
    },

    goToEditPage() {
      const baseUrl = process.env.VUE_APP_CATALOG_APP_URL;

      if (!baseUrl || !this.learningUnitId) {
        console.error('Missing base URL or learning unit ID');
        return;
      }

      const url = new URL(`/ets-4life/learning-units/${this.learningUnitId}/edit`, baseUrl);

      window.open(url.toString(), '_blank', 'noopener,noreferrer');
    },

    goToEditMethodPage(mode) {
      this.$router.push({
        name: 'design-planning/method-components',
        params: {
          learningUnitId: this.learningUnitId
        },
        query: {
          mode: mode
        }
      });
    },

    goToEditLearningPage(mode = '') {
      const baseUrl = process.env.VUE_APP_CATALOG_APP_URL;

      if (!baseUrl || !this.learningUnitId) {
        console.error('Missing base URL or learning unit ID');
        return;
      }

      const path = `/ets-4life/learning-units/${this.learningUnitId}${mode ? `/${mode}` : ''}`;
      const url = new URL(path, baseUrl);
      url.searchParams.set('tab', 'competency-information');

      window.open(url.toString(), '_blank', 'noopener,noreferrer');
    },

    goToEditGeneralInfoPage(mode = '') {
      const baseUrl = process.env.VUE_APP_CATALOG_APP_URL;
      if (!baseUrl || !this.learningUnitId) {
        console.error('Missing base URL or learning unit ID');
        return;
      }

      const path = `/ets-4life/learning-units/${this.learningUnitId}${
        mode === 'edit' ? '/edit' : ''
      }     `;
      const url = new URL(path, baseUrl);
      window.open(url.toString(), '_blank', 'noopener,noreferrer');
    }
  }
};
</script>

<style lang="scss" scoped>
// ::v-deep .info p {
//   margin-bottom: 0px !important;
// }

.text__lu-method {
  display: flow-root !important;
}

.img__cover-image {
  max-width: 480px;
  max-height: 300px;
}
</style>
